import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/app/code/apps/web/app/sentry/SentryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/code/apps/web/modules/ui/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["TolgeeNextProvider"] */ "/app/code/apps/web/tolgee/client.tsx");
